<div class="chart-panel">
  <mat-tab-group #tabGroup headerPosition="up" disableRipple="true" [@.disabled]="true" (selectedTabChange)="onSelectTab($event)">
    <mat-tab *ngIf="diagramUrl" label="Runway">
      <div class="chart-panel__tab-body chart-panel__apt-diagram">
        <a [href]="diagramUrl" target="_blank"
           class="chart-panel__link"
           [class.chart-panel__link--no-thumbnail]="!airport.thumbNail"
           [class.chart-panel__link--thumbnail-only]="!airport.diagram && airport.thumbNail">
          <div class="chart-panel__thumbnail-wrapper">
            <img *ngIf="airport.thumbNail" [src]="airport.thumbNail" class="chart-panel__apt-thumbnail" alt="Airport Diagram"/>
          </div>
          <div class="chart-panel__link-tip">
            <span class="chart-panel__link-text">
              Click to open full-size diagram
            </span>
          </div>
        </a>
      </div>
    </mat-tab>
    <mat-tab label="Satellite" #satelliteTab>
      <!-- <div class="chart-panel__tab-body">
        <agm-map
          #satelliteMap *ngIf="selectedTab === satelliteTab"
          class="chart-panel__chart"
          mapTypeId="satellite"
          [zoom]="14"
          [usePanning]="true"
          [fullscreenControl]="true"
          [latitude]="airport.location.lat"
          [longitude]="airport.location.lon">
        </agm-map>
      </div> -->
      <ng-template matTabContent>
        <div class="chart-panel__tab-body">
          <agm-map
            #satelliteMap
            class="chart-panel__chart"
            mapTypeId="satellite"
            [zoom]="14"
            [usePanning]="true"
            [fullscreenControl]="true"
            [latitude]="airport.location.lat"
            [longitude]="airport.location.lon">
          </agm-map>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab label="Sectional" #sectionalTab>
      <!-- <div class="chart-panel__tab-body">
        <app-skyvector-chart *ngIf="selectedTab === sectionalTab"
                             [lat]="airport.location.lat" [lon]="airport.location.lon">
        </app-skyvector-chart>
      </div> -->
      <ng-template matTabContent>
        <div class="chart-panel__tab-body">
          <app-skyvector-chart [lat]="airport.location.lat" [lon]="airport.location.lon">
          </app-skyvector-chart>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
